import { Injectable } from '@angular/core';
import { NewYearAudioContextService } from './new-year-audio-context.service';

@Injectable({
  providedIn: 'root',
})
export class NewYearBallsService {
  constructor(private audioContextService: NewYearAudioContextService) {}

  play(buffer: AudioBuffer): AudioBufferSourceNode {
    const context = this.audioContextService.context;

    // Create a new source for each playback
    const source = context.createBufferSource();
    const gainNode = context.createGain();

    source.buffer = buffer;

    // Connect source to gain and then to context's destination
    source.connect(gainNode);
    gainNode.connect(context.destination);

    // Set initial volume
    gainNode.gain.setValueAtTime(1, context.currentTime);

    // Start playback
    source.start();

    // Cleanup when playback ends
    source.onended = () => {
      source.disconnect();
      gainNode.disconnect();
    };

    return source;
  }
}
